import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const CopyToClipboardButton = ({ textToCopy, style, sx = {}, size, className }: any) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async (event: any) => {
        try {
            event.stopPropagation();
            await navigator.clipboard.writeText(textToCopy);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
            console.error('Kopyalama başarısız:', err);
        }
    };

    const iconFontSize = size === 'small' ? 'small' : 'inherit';

    return (
        <IconButton
            className={className}
            sx={sx}
            style={style}
            onClick={(e) => handleCopy(e)}
            color="primary"
            size={size}
        >
            {isCopied ? <CheckCircleIcon style={{ color: 'blue' }} fontSize={iconFontSize} /> : <FileCopyIcon fontSize={iconFontSize} />}
        </IconButton>
    );
};

export default CopyToClipboardButton;
